// Version management for DoIT v2
export const VERSION_INFO = {
  // Application version
  version: '2.0.0',
  
  // Build information
  build: {
    number: import.meta.env.VITE_BUILD_NUMBER || 'local',
    timestamp: import.meta.env.VITE_BUILD_TIMESTAMP || new Date().toISOString(),
    commit: import.meta.env.VITE_BUILD_COMMIT || 'local',
    branch: import.meta.env.VITE_BUILD_BRANCH || 'main',
  },
  
  // Environment information
  environment: {
    mode: import.meta.env.MODE,
    baseUrl: import.meta.env.BASE_URL,
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
  },
  
  // Technology stack
  stack: {
    react: '18.3.1',
    typescript: '5.9.3',
    vite: '7.2.4',
    tailwind: '4.1.17',
    node: '18.20.0', // Static version since process.version not available in browser
  },
  
  // Application metadata
  app: {
    name: 'DoIT v2',
    fullName: 'DoIT v2 - Business Process Management Platform',
    description: 'AI-powered business process modeling and automation platform',
    author: 'PMDG Team',
    license: 'Proprietary',
    repository: 'https://github.com/pmdg/doit-v2',
  }
};

// Helper functions
export const getVersion = () => VERSION_INFO.version;
export const getBuildInfo = () => VERSION_INFO.build;
export const getEnvironmentInfo = () => VERSION_INFO.environment;
export const getFullVersionString = () => {
  const { version, build } = VERSION_INFO;
  return `${version} (build ${build.number})`;
};
export const getBuildTimestamp = () => {
  return new Date(VERSION_INFO.build.timestamp).toLocaleString();
};
